import React from 'react';
import { Headset } from '@saleshandy/icons';
import { supportUrls } from '../../../../../shared/utils/urls';
import hasPermission from '../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../shared/utils/access-control/enums/permissions';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';
import {
  OverlayTooltip,
  Placement,
} from '../../../../../shared/design-system/components/overlay';
import { StorageUtil } from '../../../../../shared/utils/storage';
import { getUserPlanCode } from '../../../../../shared/utils/user-details';
import { SubscriptionPlans } from '../../../../../shared/utils';

const ScheduleDemoButton: React.FC = () => {
  if (!hasPermission(Permissions.SCHEDULE_DEMO_SHOW)) {
    return null;
  }

  const planCode = getUserPlanCode();
  if (
    planCode !== SubscriptionPlans.FREE &&
    planCode !== SubscriptionPlans.TRIAL
  ) {
    return null;
  }

  const scheduleDemoButtonClicked = 'schedule-demo-button-clicked';
  const isScheduleDemoButtonClicked = StorageUtil.getItem(
    'schedule-demo-button-clicked',
  );

  const redirectToScheduleDemo = () => {
    StorageUtil.setItem(scheduleDemoButtonClicked, 'true');
    window.open(supportUrls.calendlyDemoScheduleLink, '_blank');
  };

  return (
    <OverlayTooltip text="Request a Demo" placement={Placement.Bottom}>
      <div
        className="schedule-btn ml-3"
        {...accessibleOnClick(redirectToScheduleDemo)}
      >
        <Headset />
        {isScheduleDemoButtonClicked !== 'true' && (
          <span className="dot-animation" />
        )}
      </div>
    </OverlayTooltip>
  );
};

export default ScheduleDemoButton;
